import { render, staticRenderFns } from "./userVerifyCode.vue?vue&type=template&id=cb7c1d78"
import script from "./userVerifyCode.vue?vue&type=script&lang=js"
export * from "./userVerifyCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports